import { render, staticRenderFns } from "./CarInsurance.vue?vue&type=template&id=20880422&"
import script from "./CarInsurance.vue?vue&type=script&lang=js&"
export * from "./CarInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports